<template>
  <div class="home">
    <div class="wrap-cont" v-cloak>
      <header class="news-header">
        <h1>{{title}}</h1>
      </header>
      <div class="news-information">
        <div class="information">
          <img src="../assets/newsimg/advertisement-timeIcon.png"/>
          <span class="news-information-data">{{public_time}}</span>
          <span class="news-information-icon">|</span>
          <span class="news-information-name">{{news_type_name}}</span>
        </div>
        <p class="news-information-title">中科名兽医</p>
      </div>
      <div class="news-banner">
        <img src="../assets/newsimg/advertisement-banner.png"/>
        <div class="qrcode">
          <div id="qrcode"></div>
        </div>
      </div>
    </div>
    <div class="contentName" v-html="content" ref="contentbox" v-cloak></div>
    <div class="news-advertisement-read" v-cloak>
      <div class="news-reading-volume">
        <img src="../assets/newsimg/yueduliang@3x.png"/>
        <span>{{reader_num}}阅读</span>
        <p v-if="original_link !== ''" class="wwd">|</p>
        <a v-if="original_link !== ''" :href="original_link" class="hrefUrl">阅读原文</a>
      </div>
      <div class="news-thumbsup" @click="islook">
        <!-- <p>+1</p>
        <a>-1</a> -->
        <img class="img1" v-if="look == true" src="../assets/newsimg/dianzanliang_normal@3x.png"/>
        <img class="img2" v-else src="../assets/newsimg/dianzanliang@3x.png"/>
        <span>好看</span>
      </div>
    </div>
    <footer class="news-footer" v-if="info_from !== ''">
      <p class="info_from">{{info_from}}</p>
      <p>内容经过本平台汇编，若有不妥之处，</p><p>请联系400-001-2129。</p>
    </footer>
    <div v-if="wxtype == '1'">
      <div class="appheight"></div>
      <!-- <div class="openapp" id="openapp" @click="openApp">打开中科名兽医APP</div> -->
      <a class="openapp" id="openapp" @click="openApp1">打开中科名兽医APP</a>
    </div>
  </div>
</template>

<script>

import QRCode  from "qrcodejs2"
import { iswx, wxshare } from '@/utils/utils.js'
import { newsdetail,getclassList } from '@/api/resetApi.js'

export default {
  name: 'Home',
  components: { QRCode },
  data(){
    return{
      showCard:false,
      link:  window.location.protocol + '//' + window.location.host,
      id: '',
      user_id: '',
      content: '',
      title: '',
      news_type_name: '',
      public_time: '',
      reader_num: '',
      original_link: '',
      info_from: '',
      img_uri: '',
      wxtype: '',
      look: true,
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      goodsList: [],
    }
  },
  created(){
    this.id = this.$route.query.id
    this.user_id = this.$route.query.user_id
    this.wxtype = this.$route.query.wx
    console.log('dddd=',this.wxtype)
    this.$nextTick (function () {
       this.qrcode();
    })
    this.newsdetail()
    this.test()
  },
  methods: {
    async test() {
      let data = {
        topicId: this.topicId,
      }
      const res = await getclassList(data)
      console.log(res)
      try {
        if (res.data.code == 200) {
          
        } else {
          Toast.fail(res.data.msg);
        }
      } catch (error) {}
    },
    // openApp() {
    //   this.$router.push({
    //     name: 'OpenApp',
    //     query:{
    //       id: this.id,
    //     }
    //   })
    // },
    openApp1() {
      new JMLink({
        jmlink: "https://acpeic.jmlk.co/AATk",
        button: document.querySelector('a#openapp'),
        autoLaunchApp : false,
        downloadWhenUniversalLinkFailed: true,
        inapp : false,
        params: {}
      });
    },
    islook() {
      this.look = !this.look;
    },
    qrcode () {
      console.log('link1',this.link)
      this.link = this.link + '/zkmsytest/index.html#/shareregister?user_id=' + this.user_id
      console.log('link2',this.link)
      let qrcode = new QRCode('qrcode', {
          width: 65,
          height: 63,        // 高度
          text:  this.link,   // 二维码内容
          // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',   // 背景色
          // foreground: '#ff0'    // 前景色
      })
    },
    async newsdetail() {
      let data = new URLSearchParams();
      data.append('user_id',this.user_id)
      data.append('id',this.id)
      const res = await newsdetail(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.content = res.data.obj[0].content
          this.title = res.data.obj[0].title
          this.news_type_name = res.data.obj[0].news_type_name
          this.public_time = res.data.obj[0].public_time
          this.reader_num = res.data.obj[0].reader_num
          this.original_link = res.data.obj[0].original_link
          this.info_from = res.data.obj[0].info_from
          this.img_uri = res.data.obj[0].img_uri
          if (iswx() === true) {
            this.$nextTick (function () {
              let arr = this.$refs.contentbox.getElementsByTagName("p")
              let num = arr.length
              let list =  [...arr];
              if (list[arr.length-1].innerText.indexOf("文献") != -1) {
                list[arr.length-1].style.display = 'none'
              }
              if (list[arr.length-1].innerText.indexOf("附件：") != -1) {
                list[arr.length-1].style.display = 'none'
              }
              console.log('innerText',list[arr.length-1].innerText.indexOf("文献"))
            })
          }
          wxshare(this.img_uri,this.title,)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.news-header {
  h1 {
    padding: 20px 15px 10px;
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color:rgba(34,34,34,1);
    line-height: 20px;
  }
}
.news-information{
	display: flex;
  height: 40px;
	padding: 0 15px;
	justify-content: space-between;
	font-size: 14px;
	color:rgba(102,102,102,1);
	line-height: 40px;
  .information {
    display: flex;
    img {
      width: 20px;
      height:20px;
      padding: 10px 10px 0 0;
    }
    .news-information-title{
      color: #004EA2;
    }
    .news-information-icon{
      padding: 0 10px;
      font-size: 16px!important;
      color:#979797;
    }
  }
}
.news-banner{
	padding: 10px 15px 0;
	position: relative;
  img {
    width: 100%;
  }
  .qrcode{
    width: 65px;
    height: 63px;
    background: #fff;
    position: absolute;
    right: 17%;
    bottom: 70px;
    padding: 5px;
    overflow: hidden;
    #qrcode {
      line-height: 60px;
    }
  }
}
.news-advertisement-read {
  padding: 10px 15px 10px;
	display:flex;
	justify-content: space-between;
	position:relative;
  img {
    width: 20px;
    height:20px;
  }
  .news-reading-volume {
    display:flex;
    font-size: 14px;
	  color:rgba(153,153,153,1);
    span {
      margin: 2px 0 0 5px;
    }
    p {
      padding: 2px 5px 0;
    }
    a {
      color:rgba(38,60,146,1);
      margin-top: 3px;
      font-size: 14px;
    }
  }
  .news-thumbsup {
    display:flex;
    p {
      position: absolute;
      right: 5%;
      top: -.5rem;
      color: #ff8566;
      font-size: .4rem;
      font-weight: 600;
      display:none;
    }
    a {
      position: absolute;
      right: 5%;
      top: -.5rem;
      color: #999;
      font-size: .4rem;
      font-weight: 600;
      display:none;
    }
    span {
      font-size: 14px;
      color:#333;
      margin-top: 3px;
    }
    .active {
      color:#999;
    }
  }
}
.news-footer{
	width:100%;
	background: url('../assets/newsimg/footer.png') no-repeat;
	background-size: 100% 100%; 
	color:#fff;
	text-align: center;
	padding: 15px 0;
	color: #fff;
	font-size: 14px;
	opacity:.9;
	letter-spacing: 1px;
	line-height: 25px;
}
.contentName {
  width: 92%;
	margin: 0 15px;
	line-height: 20px;
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  img {
    width: 100%;
    height: 100%;
  }
  em {
    font-style:normal;
  }
  p,span {
    text-align: left!important;
    font-family: FZLTXHJW--GB1-0!important;
    font-size: 16px!important;
    line-height: 20px!important;
    margin-bottom: 10px!important;
    word-wrap: break-word;
    word-break: normal;
  }
  strong {
    font-size: 16px!important;
  }
}
.appheight {
  height: 50px;
}
.openapp {
  width: 100%;
  height: 50px;
  background: -webkit-linear-gradient(left, #0097e0 , #004ea2);
  // background: -o-linear-gradient(left, #0097e0, #004ea2);
  // background: -moz-linear-gradient(left, #0097e0, #004ea2);
  // background: linear-gradient(left,#0097e0, #004ea2);
  background-size: 100% 100%;
  position: fixed;
  bottom: 0;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>

